import {useQuery} from '@tanstack/react-query';

import {GetListOutput, QueryOptionsForList} from '@shared/api';
import {getVideoSchedules, GetVideoSchedulesParams} from '../api';
import {QUERY__VIDEO_SCHEDULES} from '../queryKeys';
import {VideoEventSchedule} from '../types';

export const useGetVideoSchedules = <
  SelectedData = GetListOutput<VideoEventSchedule>,
>(
  params: GetVideoSchedulesParams,
  options?: QueryOptionsForList<VideoEventSchedule, SelectedData>,
) => {
  return useQuery({
    queryKey: [QUERY__VIDEO_SCHEDULES, params],
    queryFn: () => getVideoSchedules(params),
    ...options,
  });
};
